import { render, staticRenderFns } from "./AdminSidebarItem.vue?vue&type=template&id=5ca31725&scoped=true"
import script from "./AdminSidebarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSidebarItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminSidebarItem.vue?vue&type=style&index=0&id=5ca31725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca31725",
  null
  
)

export default component.exports